export default __webpack_public_path__ + "static/media/fndisplay.ad396ae3.mp4";